interface TablePaginationProps {
  page: number
  totalPages: number
  onPrev: () => void
  onNext: () => void
}

const TablePagination = ({
  page,
  totalPages,
  onPrev,
  onNext,
}: TablePaginationProps) => (
  <div className='border-border-main flex items-center justify-between border-t px-4 py-3'>
    <span className='text-text-tertiary text-sm'>
      Page {page + 1} of {totalPages}
    </span>
    <div className='flex gap-2'>
      <button
        disabled={page === 0}
        onClick={onPrev}
        className='border-border-main text-text-secondary hover:bg-neutral-dimmed rounded-lg border px-4 py-2 text-sm disabled:opacity-40'
      >
        Prev
      </button>
      <button
        disabled={page >= totalPages - 1}
        onClick={onNext}
        className='border-border-main text-text-secondary hover:bg-neutral-dimmed rounded-lg border px-4 py-2 text-sm disabled:opacity-40'
      >
        Next
      </button>
    </div>
  </div>
)

export default TablePagination
